<h1>割引・割増一括設定</h1>

<mat-card class="cur-card">
  <form (ngSubmit)="onSubmit()" [formGroup]="priceInputForm">
    <app-sgkb714d-bulkset></app-sgkb714d-bulkset>
  </form>
</mat-card>